import { render } from "./EmployeeAdvances.vue?vue&type=template&id=5a498ba8&scoped=true"
import script from "./EmployeeAdvances.vue?vue&type=script&lang=js"
export * from "./EmployeeAdvances.vue?vue&type=script&lang=js"

import "./EmployeeAdvances.vue?vue&type=style&index=0&id=5a498ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a498ba8"]])

export default __exports__